const experienceData = [
    {
        id: 1,
        role: "Frontend Developer",
        company: "Women Coders Network (Global Nonprofit)",
        date: "Mar 2025 – Present",
        location: "Remote",
        description: [
            "Built and deployed a responsive community website with React, TypeScript, and Tailwind CSS, supporting a global community of 500+ members across mobile, tablet, and desktop experiences.",
            "Translated 4+ Figma designs into reusable React components with responsive layouts and WCAG 2.1 AA accessibility standards, achieving a 90% Lighthouse accessibility score.",
            "Implemented asynchronous JavaScript functionality for dynamic content loading and interactive user experiences, contributing to a production site with 80% uptime.",
            "Collaborated with a 3-person cross-functional development team using Git/GitHub workflows, code reviews, and shared development practices to ship features while maintaining design fidelity."
        ],
        skills: ["TypeScript", "Tailwind CSS", "React", "Figma", "Web Accessibility", "Git/GitHub"]
    },
    {
        id: 2,
        role: "Data Analyst Intern",
        company: "Wipro",
        date: "March 2022 – July 2022",
        location: "Bangalore, India",
        description: [
            "Processed over 200k COVID-19 case records from the MoHFW India's public database, leveraged MySQL to categorize data into active, recovered, and deceased groups for accurate tracking. ",
            "Developed interactive reporting tools in Hue Dashboards, reducing the time required for team members to identify district-level trends and generate reports of the 6 high-risk districts."
        ],
        skills: ["MySQL", "Hue Dashboards"]
    }
];

export default experienceData;
